import {
  IconHome,
  IconFilePencil,
  IconCalendarEvent,
  Icon2fa,
  IconSettings,
  IconPoint,
} from '@tabler/icons-react';

import { uniqueId } from 'lodash';

const roles = localStorage.getItem('roles');

const Menuitems = [
  {
    navlabel: true,
    subheader: 'Trang chủ',
    subheaderI18n: 'MENU:home',
  },
  {
    id: uniqueId(),
    title: 'Bảng điều khiển',
    titleI18n: 'MENU:dashboard',
    icon: IconHome,
    href: '/',
  },
  {
    navlabel: true,
    subheader: 'Quản lý',
    subheaderI18n: 'MENU:management',
  },
  // {
  //   id: uniqueId(),
  //   title: 'Sự kiện',
  //   titleI18n: 'MENU:event',
  //   icon: IconCalendarEvent,
  //   href: '/event',
  //   children: [
  //     {
  //       id: uniqueId(),
  //       title: 'Danh sách sự kiện',
  //       titleI18n: 'MENU:event_list',
  //       icon: IconCalendarEvent,
  //       href: '/event',
  //     },
  //   ],
  // },

  {
    id: uniqueId(),
    title: 'Danh sách sự kiện',
    titleI18n: 'MENU:event_list',
    icon: IconCalendarEvent,
    href: '/event',
  },
  {
    navlabel: true,
    subheader: 'Hệ thống',
    subheaderI18n: 'MENU:system',
  },
  {
    id: uniqueId(),
    title: 'MENU:setting',
    titleI18n: 'MENU:setting',
    icon: IconSettings,
    href: '/smtp',
    children: [
      {
        id: uniqueId(),
        title: 'SMTP',
        titleI18n: 'MENU:smtp',
        icon: IconPoint,
        href: '/smtp',
      },
      // {
      //   id: uniqueId(),
      //   title: 'Tùy chỉnh giao diện',
      //   titleI18n: 'MENU:theme',
      //   icon: IconPoint,
      //   isLayout: true,
      //   href: '#',
      // },
      {
        id: uniqueId(),
        title: 'Nhóm động',
        titleI18n: 'MENU:dynamic_group_code',
        icon: IconPoint,
        href: '/dynamic-group-code',
      },
      {
        id: uniqueId(),
        title: 'Lự chọn động',
        titleI18n: 'MENU:dynamic_option',
        icon: IconPoint,
        href: '/dynamic-option',
      },
      {
        id: uniqueId(),
        title: 'Mẫu E-Card',
        titleI18n: 'MENU:template_e_card',
        icon: IconPoint,
        href: '/template-ecard',
      },
    ],
  },
];

export default Menuitems;
